"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTrace = updateTrace;

function updateTrace(trace, value) {
  var last = trace[trace.length - 1];

  if (last !== value) {
    trace.push(value);
  }

  return trace;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vanilla-swipe/lib/utils/updateTrace.js
// module id = 595
// module chunks = 0